import { render } from "./VisitorDetailForm.vue?vue&type=template&id=4ffd6c5c&scoped=true"
import script from "./VisitorDetailForm.vue?vue&type=script&lang=js"
export * from "./VisitorDetailForm.vue?vue&type=script&lang=js"

import "./VisitorDetailForm.vue?vue&type=style&index=0&id=4ffd6c5c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffd6c5c"]])

export default __exports__